/**
 * Error Logging Hooks
 */

import { useCallback, useEffect } from 'react';
import { useCurrentUser } from '@shared/hooks/useCurrentUser';
import { errorLogger } from '@shared/services/ErrorLogger';
import {
  ErrorContext,
  ErrorBreadcrumb,
  ContextualError,
} from '@shared/types/ErrorLogging';
import { ContextCollector } from '@shared/utils/errorUtils';

export function useErrorLogger() {
  const { data: currentUser } = useCurrentUser();

  useEffect(() => {
    if (currentUser?.id) {
      errorLogger.setUserContext(currentUser.id.toString(), currentUser.email);
    } else {
      errorLogger.clearUserContext();
    }
  }, [currentUser]);

  const logError = useCallback(
    (error: Error | ContextualError, context?: Partial<ErrorContext>) => {
      errorLogger.logError(error, context);
    },
    []
  );

  const addBreadcrumb = useCallback(
    (
      message: string,
      category: ErrorBreadcrumb['category'],
      level: ErrorBreadcrumb['level'] = 'info',
      data?: Record<string, any>
    ) => {
      const breadcrumb = ContextCollector.createBreadcrumb(
        message,
        category,
        level,
        data
      );
      errorLogger.addBreadcrumb(breadcrumb);
    },
    []
  );

  return {
    logError,
    addBreadcrumb,
  };
}
